<template>
  <v-img
    v-bind="imgAttrs"
    v-on="$listeners"
  >
    <slot />
  </v-img>
</template>

<script>
  export default {
    name: 'BaseImage',

    computed: {
      imgAttrs () {
        const attrs = { ...this.$attrs }
        if (!Object.prototype.hasOwnProperty.call(attrs, 'alt')) {
          attrs.alt = ''
        }
        // Enable native lazy loading by default
        if (!attrs.eager) {
          attrs.options = { ...attrs.options, root: null, threshold: 0.1 }
        }
        return attrs
      },
    },
  }
</script>
